import angular from 'angular';
import _ from 'lodash';

import SubEntity from '../seller/sub-entity.data';

(function () {
    'use strict';
    angular.module('app.core').factory('LegalEntityGroup', LegalEntityGroupData);

    LegalEntityGroupData.$inject = ['LegalEntity', '$translate'];

    function LegalEntityGroupData(LegalEntity, $translate) {
        LegalEntityGroup.prototype = {
            build: build,
            isDefaultGroup: isDefaultGroup,
        };

        function LegalEntityGroup(LegalEntityGroupData) {
            if (LegalEntityGroupData) {
                this.build(LegalEntityGroupData);
            }
        }

        return LegalEntityGroup;

        /////////////////////

        function build(LegalEntityGroupData) {
            this.id = LegalEntityGroupData.id;
            this.name = LegalEntityGroupData.name;
            this.description = LegalEntityGroupData.description;
            this.type = LegalEntityGroupData.type;
            this.principalName = LegalEntityGroupData.principalName;
            this.companies = _.map(LegalEntityGroupData.legalEntities, function (leg) {
                return new LegalEntity(leg);
            });
            this.subEntities = _.map(LegalEntityGroupData.subEntities, function (sub) {
                return new SubEntity(sub, $translate);
            });
        }

        function isDefaultGroup() {
            return this.type === 'ALL' || this.type === 'INVITED_SELLER';
        }
    }
})();
